import Vue from 'vue';
import Vuex from 'vuex';
import Axios from 'axios';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    mobileCreatives: [],
    desktopCreatives: [],
    isMenuShifted: false,
  },
  mutations: {
    SET_CREATIVES_MOBILE: (state, payload) => {
      state.mobileCreatives = payload;
    },
    SET_CREATIVES_DESKTOP: (state, payload) => {
      state.desktopCreatives = payload;
    },
    CHANGE_SHIFT: (state, payload) => {
      if (payload) {
        state.isMenuShifted = payload;
      } else {
        state.isMenuShifted = !state.isMenuShifted;
      }
    },
  },
  getters: {
    isMenuShifted(state) {
      return state.isMenuShifted;
    },
    getMobileCreatives(state) {
      return state.mobileCreatives;
    },
    getDesktopCreatives(state) {
      return state.desktopCreatives;
    },
  },
  actions: {
    fetchMobileCreatives: (context) => {
      Axios
        .get('/data/mobile.json')
        .then((response) => {
          context.commit('SET_CREATIVES_MOBILE', response.data.creatives);
        });
    },
    fetchDesktopCreatives: (context) => {
      Axios
        .get('/data/desktop.json')
        .then((response) => {
          context.commit('SET_CREATIVES_DESKTOP', response.data.creatives);
        });
    },
  },
  modules: {
  },
});
